<template>
  <b-dropdown right variant="ghost-blue" class="ui-dashboard-menu-dropdown widget-selector-dropdown mr-2">
    <template #button-content>
      <span>{{ $gettext('Widgets') }}</span>
    </template>
    <b-dropdown-form>
      <template v-for="widget_btn in getAvailableWidgets">
        <div
          class="dropdown-item"
          v-if="!hiddenWidget(widget_btn.type)"
          :class="{ 'disabled': (widget_btn.unique && widgetCount(widget_btn.type) > 0) }"
          :key="'aw_' + widget_btn.type"
          @click="toggleWidget(widget_btn.type)"
        >
          <div class="item-controls item-controls--single">
            <font-awesome-icon v-if="widgetCount(widget_btn.type) < 1" :class="{}" :icon="'fa-regular fa-square'" />
            <font-awesome-icon v-else :class="{}" :icon="'fa-solid fa-square-check'" />
          </div>
          <!-- <span class="widget-count-badge" :class="{ 'none': widgetCount(widget_btn.type) < 1 }">{{ widgetCount(widget_btn.type) }}</span> -->
          <span class="dropdown-item-title">{{ $gettext(widget_btn.name) }}</span>
          <span v-if="widget_btn.premium" class="widget-premium-badge">Premium</span>
          <!-- <div class="item-controls">
            <font-awesome-icon @click="addWidget(widget_btn.type)" :class="{}" :icon="'fa-solid fa-square-plus'" />
            <font-awesome-icon @click="removeWidget(widget_btn.type)" :class="{ 'disabled': widgetCount(widget_btn.type) < 1 }" :icon="'fa-solid fa-square-minus'" />
          </div> -->
        </div>
      </template>
    </b-dropdown-form>
    <b-dropdown-divider />
    <b-dropdown-item @click="resetConfig()">
      <font-awesome-icon :icon="'fa-solid fa-rotate-left'" />
      {{ $gettext('Reset to default') }}
    </b-dropdown-item>
  </b-dropdown>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "WidgetDropdown",
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters({ 
      getAvailableWidgets: "dashboard/getAvailableWidgets",
      getHasAccountant: "dashboard/getHasAccountant",
      getHeroesStatus: "dashboard/getHeroesStatus",
      getTempUserWidgets: "dashboard/getTempUserWidgets"
    })
  },
  methods: {
    toggleWidget (widget_type) {
      if (this.widgetCount(widget_type) < 1) {
        this.addWidget(widget_type)
      } else {
        this.removeWidget(widget_type)
      }
    },
    addWidget (widget_type) {
      this.$emit('add-widget', widget_type)
    },
    removeWidget (widget_type) {
      const widget_list = this.getTempUserWidgets.filter(obj => obj.type === widget_type)
      if (widget_list.length > 0) {
        this.$emit('remove-widget', widget_list[0].id)
      }
    },
    removeAllWidgets (widget) {
      const widget_list = this.getTempUserWidgets.filter(obj => obj.type === widget)
      if (widget_list.length > 0) {
        widget_list.forEach(widget => {
          this.$emit('remove-widget', widget.id)
        })
      }
    },
    widgetCount (widget) {
      return this.getTempUserWidgets.filter(obj => obj.type === widget).length
    },
    resetConfig () {
      this.$emit('reset-config', false)
    },
    hiddenWidget (widget_type) {
      let hidden = false
      if (widget_type === 'accountant' && !this.getHasAccountant) {
        hidden = true
      }
      if (widget_type === 'heroes-program' && !this.getHeroesStatus) {
        hidden = true
      }
      return hidden
    },
    getWidgetSelectorIcon (widget_btn) {
      let icon = ''
      const widget_count = this.widgetCount(widget_btn.type)
      if (widget_count) {
        if (widget_btn.unique && widget_count > 0) {
          icon = 'fa-solid fa-square-check'
        } else {
          icon = 'fa-regular fa-square-plus'
        }
      } else {
        icon = 'fa-regular fa-square'
      }
      return icon
    }
  },
}
</script>

<style lang="scss">
.widget-selector-dropdown {
  .dropdown-item {
    width: 100%;
    line-height: 1.3;
    font-size: 15px;
    &.disabled {
      pointer-events: none;
      .widget-count-badge {
        opacity: 0.2;
      }
      .item-controls {
        svg.svg-inline--fa {
          opacity: 0.3; color: $colorUnassigned;
        }
      }
    }
  }
  .dropdown-item-title {
    margin: 0 !important;
    padding: 0 0.5rem;
  }
  .b-dropdown-form {
    padding: 0;
    user-select: none
  }
  .item-controls {
    margin-left: auto;
    display: flex;
    align-items: center;
    &--single {
      margin: 0;
    }
    svg.svg-inline--fa {
      font-size: 17px;
      color: $colorBrand;
      font-size: 20px;
      opacity: 0.6;
      margin-right: 0px !important;
      &:first-child { margin-right: 3px !important; }
      transition: all 0.2s ease;
      &:not(.disabled) { 
        cursor: pointer; 
        &:hover { color: $colorBrand800; opacity: 1; }
      }
      &.disabled { opacity: 0.3; color: $colorUnassigned; }
    }
  }
}

.widget-premium-badge {
  border-radius: 12px;
  font-size: 12px;
  letter-spacing: 0px;
  line-height: 1;
  padding: 5px 10px;
  padding-bottom: 4px;
  background: $colorBrand;
  color: #ffffff;
  margin: 0 !important;
  margin-left: 15px !important;
}

.widget-count-badge {
  border-radius: 50em;
  font-size: 12px;
  letter-spacing: 0px;
  line-height: 1;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: $colorBrand;
  margin: 0 !important;
  margin-right: 5px;
  color: white;
  opacity: 0.6;
  &.none { opacity: 0.4; background: $colorUnassigned; }
}
</style>